module.exports = __webpack_public_path__ + "static/media/starfighter-alt.351eb6f0.svg";